import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { homeForGroups } from '../auth/routing';

export default function ProtectedRoute({ children, allowedGroups }) {
  const { user, initializing } = useAuth();
  if (initializing) return null;
  if (!user) return <Navigate to="/login" replace />;

  if (allowedGroups && !allowedGroups.some((g) => user.groups.includes(g))) {
    const fallback = homeForGroups(user.groups);
    return <Navigate to={fallback || '/login'} replace />;
  }

  return children;
}
